import { createSlice } from "@reduxjs/toolkit";
const brandsSlice = createSlice({
    name: 'brands',
    initialState: {
        brandsList: []
    },
    reducers: {
        setBrandsList: (state, action) => {
            state.brandsList = action.payload.brandsList
        }
    }
});
export const addBrandsList = brandsSlice.actions.setBrandsList;
export default brandsSlice.reducer;
